import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";
import { SuscriptionDataType } from "@/api/SuscriptionsApi";
import { TICKET_PRINT_FORMANT_ID } from "./Constants";
import { CreditnoteApi, CreditnoteDataType } from "@/api/CreditnoteApi";
import { RecibeApi, RecibeDataType } from "@/api/RecibeApi";
import { DebitnoteApi, DebitnoteDataType } from "@/api/DebitnoteApi";
import { InvoiceRelatedAttributes } from "@/formTypes/InvoiceDataType";
import { InvoiceFormDataKeys } from "@/generated/InvoiceFormDataKeys";
import { CreditnoteRelatedAttributes } from "@/formTypes/CreditnoteDataType";
import { CreditnoteFormDataKeys } from "@/generated/CreditnoteFormDataKeys";
import { DebitnoteFormDataKeys } from "@/generated/DebitnoteFormDataKeys";
import { DebitnoteRelatedAttributes } from "@/formTypes/DebitnoteDataType";
import { RecibeRelatedAttributes } from "@/formTypes/RecibeDataType";
import { RecibeFormDataKeys } from "@/generated/RecibeFormDataKeys";
import { toNumberFormat } from "./Utils";
import { InvoicePaymentApi, InvoicePaymentDataType } from "@/api/InvoicePaymentApi";
import { InvoicePaymentFormDataKeys } from "@/generated/InvoicePaymentFormDataKeys";
import { InvoicePaymentRelatedAttributes } from "@/formTypes/InvoicePaymentDataType";
import { normalizeClientStatusRow } from "./DocumentStatus";
import moment from "moment";

export const checkInvoiceTicketPrint = async (suscription?: SuscriptionDataType, invoice?: InvoiceDataType) => {
    if (suscription?.formato_impresion === TICKET_PRINT_FORMANT_ID && invoice != null) {
        const invoiceData = await InvoiceApi.get(`${invoice.id}`, {
            selectionSet: [
                ...InvoiceFormDataKeys.filter(k => !InvoiceRelatedAttributes.includes(k)),
                "currency.*",
                "client.*",
                "invoiceProducts.*",
                "invoiceProducts.product.*",
                "invoicePayments.*"
            ]
        })
        await printInvoiceData(suscription, invoiceData)
    }
}

export const checkCreditnoteTicketPrint = async (suscription?: SuscriptionDataType, creditnote?: CreditnoteDataType) => {
    if (suscription?.formato_impresion === TICKET_PRINT_FORMANT_ID && creditnote != null) {
        const creditnoteData = await CreditnoteApi.get(`${creditnote.id}`, {
            selectionSet: [
                ...CreditnoteFormDataKeys.filter(k => !CreditnoteRelatedAttributes.includes(k)),
                "currency.*",
                "client.*",
                "invoice.*",
                "creditnoteProducts.*",
                "creditnoteProducts.product.*"
            ]
        })
        printCreditnoteData(suscription, creditnoteData)
    }
}

export const checkDebitnoteTicketPrint = async (suscription?: SuscriptionDataType, debitnote?: DebitnoteDataType) => {
    if (suscription?.formato_impresion === TICKET_PRINT_FORMANT_ID && debitnote != null) {
        const debitnoteData = await DebitnoteApi.get(`${debitnote.id}`, {
            selectionSet: [
                ...DebitnoteFormDataKeys.filter(k => !DebitnoteRelatedAttributes.includes(k)),
                "currency.*",
                "client.*",
                "invoice.*",
                "debitnoteProducts.*",
                "debitnoteProducts.product.*"
            ]
        })
        printDebitnoteData(suscription, debitnoteData)
    }
}

export const checkInvoicePaymentTicketPrint = async (suscription?: SuscriptionDataType, invoicePayment?: InvoicePaymentDataType) => {
    if (suscription?.formato_impresion === TICKET_PRINT_FORMANT_ID && invoicePayment != null) {
        const invoicePaymentData = await InvoicePaymentApi.get(`${invoicePayment.id}`, {
            selectionSet: [
                ...InvoicePaymentFormDataKeys.filter(k => !InvoicePaymentRelatedAttributes.includes(k)),
                "currency.*",
                "invoice.*",
                "invoice.client",
                "creditOperator.*",
                "bankAccount.*"
            ]
        })
        const invoiceData = await InvoiceApi.get(`${invoicePayment.invoiceId}`, {
            selectionSet: [
                ...InvoiceFormDataKeys.filter(k => !InvoiceRelatedAttributes.includes(k)),
                "currency.*",
                "client.*",
                "creditnotes.*",
                "debitnotes.*",
                "invoicePayments.*",
                "interestEntries.*",
                "apliedCreditnote.*",
                "recibe.*"
            ]
        })
        const today = moment();
        const invoiceCalculatedData = await normalizeClientStatusRow(today.format("YYYY-MM-DD"),
            {
                kind: "invoice",
                data: invoiceData
            },
            {
                isInterestOnDue: false,
                interestOnDue: 0
            })

        printInvoicePaymentData(suscription, invoicePaymentData, invoiceCalculatedData.saldo || invoiceData.total)
    }
}

export const checkRecibeTicketPrint = async (suscription?: SuscriptionDataType, recibe?: RecibeDataType) => {
    if (suscription?.formato_impresion === TICKET_PRINT_FORMANT_ID && recibe != null) {
        const recibeData = await RecibeApi.get(`${recibe.id}`, {
            selectionSet: [
                ...RecibeFormDataKeys.filter(k => !RecibeRelatedAttributes.includes(k)),
                "currency.*",
                "client.*",
                "creditOperator.*",
                "bankAccount.*"
            ]
        })
        printRecibeData(suscription, recibeData)
    }
}

export const printInvoicePaymentData = (suscription: SuscriptionDataType, invoicePayment: InvoicePaymentDataType, pending?: number) => {
    const ticketData = {
        Suscription: suscription,
        InvoicePayment: {
            ...invoicePayment,
            forma_pago: invoicePayment.formaPago,
            num_aprobacion: invoicePayment.numAprobacion,
            digitos_tarjeta: invoicePayment.digitosTarjeta,
            id: "",
            pendiente: pending
        },
        Invoice: {
            ...invoicePayment.invoice,
            client_id: invoicePayment.invoice.client.codigo
        },
        Client: invoicePayment.invoice.client,
    }
    const copias = 1
    const url = `${suscription.printer_url}/invoicePayments/printInvoicePayment/${invoicePayment.id}/${suscription.numero}/${copias}`;
    submitPrint(url, ticketData)
}

export const printRecibeData = (suscription: SuscriptionDataType, recibe: RecibeDataType) => {
    const ticketData = {
        Suscription: suscription,
        Recibe: {
            ...recibe,
            id: recibe.numero,
            abono: toNumberFormat(`${recibe.abono}`),
            total: toNumberFormat(`${recibe.total}`)
        },
        Client: recibe.client,
    }
    const copias = 1
    const url = `${suscription.printer_url}/recibes/printRecibe/${recibe.numero}/${suscription.numero}/${copias}`;
    submitPrint(url, ticketData)
}

export const printDebitnoteData = (suscription: SuscriptionDataType, debitnote: DebitnoteDataType) => {
    const ticketData = {
        Suscription: suscription,
        Debitnote: {
            ...debitnote,
            id: debitnote.numero,
            total: toNumberFormat(`${debitnote.total}`)
        },
        Client: debitnote.client,
    }
    const copias = 1
    const url = `${suscription.printer_url}/debitnotes/printDebitnote/${debitnote.numero}/${suscription.numero}/${copias}`;
    submitPrint(url, ticketData)
}

export const printCreditnoteData = (suscription: SuscriptionDataType, creditnote: CreditnoteDataType) => {
    const ticketData = {
        Suscription: suscription,
        Creditnote: {
            ...creditnote,
            id: creditnote.numero,
            total: toNumberFormat(`${creditnote.total}`)
        },
        Client: creditnote.client,
    }
    const copias = 1
    const url = `${suscription.printer_url}/creditnotes/printCreditnote/${creditnote.numero}/${suscription.numero}/${copias}`;
    submitPrint(url, ticketData)
}

export const printInvoiceData = async (suscription: SuscriptionDataType, invoice: InvoiceDataType) => {
    let invoicesProducts = invoice.invoiceProducts
    let invoicesPayment = invoice.invoicePayments

    const ticketData = {
        Suscription: suscription,
        Invoice: {
            ...invoice,
            id: invoice.numero,
            subtotal: toNumberFormat(`${invoice.subtotal}`),
            impuestos: toNumberFormat(`${invoice.impuestos}`),
            descuento: toNumberFormat(`${invoice.descuento}`),
            total: toNumberFormat(`${invoice.total}`)
        },
        Client: invoice.client,
        InvoiceProduct: invoicesProducts?.map(ip => {
            return {
                ...ip,
                Product: ip.product
            }
        }),
        InvoicePayment: invoicesPayment?.map(ip => {
            return {
                ...ip,
                forma_pago: ip.formaPago,
                digitos_tarjeta: ip.digitosTarjeta,
                num_aprobacion: ip.numAprobacion,
            }
        }),
    }
    const copias = 1
    const url = `${suscription.printer_url}/invoices/printTicketInvoice/${invoice.numero}/${suscription.numero}/${copias}`;
    submitPrint(url, ticketData)
}

function toUrlEncoded(data: any, prefix?: string, out: URLSearchParams = new URLSearchParams()): URLSearchParams {
    Object.entries(data || {}).forEach(([key, value]) => {
        const k = prefix ? `${prefix}[${key}]` : key;

        if (value === null || value === undefined) {
            out.append(k, "");
        } else if (Array.isArray(value)) {
            value.forEach((v, i) => {
                if (typeof v === "object" && v !== null) {
                    toUrlEncoded(v, `${k}[${i}]`, out);
                } else {
                    out.append(`${k}[${i}]`, String(v));
                }
            });
        } else if (typeof value === "object") {
            toUrlEncoded(value, k, out);
        } else {
            out.append(k, String(value));
        }
    });
    return out;
}

async function submitPrint(url: string, data: any) {
    const body = toUrlEncoded(data).toString();
    fetch(url, {
        method: "POST",
        mode:"cors",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body,
    }).then(async (response) => {
        if (!response.ok) {
            // si el servidor responde con error HTTP
            const errorText = await response.text();
            console.error("Error en respuesta:", errorText);
            throw new Error(errorText);
        }
        return response.json(); // parsea a JSON
    })
        .then((responseData) => {
            console.log("Respuesta OK:", responseData);
            setTimeout(() => {
                window.close();
            }, 500);
        })
        .catch((error) => {
            console.error("Error en fetch:", error);
        });
}